<span>
    <span role="button" class="material-icons-sharp font-8 mt-1 primary-text-100 ms-3" [ariaDisabled]="!username()">person</span>                         
</span>